import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import React from 'react'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'
import { useIntl } from 'react-intl'

type Props = {
  offer: App.VillaOffer | App.VillaOfferSummary
  locationHeading?: string
  locationSubheading?: string
}

function VillaLocationCaption(props: Props) {
  const { offer } = props
  const intl = useIntl()

  const locationLabel = offer.locationHeading && offer.locationSubheading
    ? intl.formatMessage(
        {
          id: 'A5196XNeUN',
          defaultMessage: '{locationHeading}, {locationSubheading}',
          description: 'Villa offer card location heading and subheading separated by comma',
        },
        { locationHeading: offer.locationHeading, locationSubheading: offer.locationSubheading },
      )
    : (offer.locationHeading || offer.locationSubheading)

  return (
    <Group direction="horizontal" gap={4}>
      <Caption colour="neutral-two" variant="large">
        {locationLabel}
      </Caption>
      <Caption variant="large" colour="neutral-three">
        {intl.formatMessage(
          {
            id: 'dBUBcFx19E',
            defaultMessage: '{sep} {villa}',
            description: 'Separator and villa label for villa location display',
          },
          {
            sep: intl.formatMessage(middleDotSeparatorMessage),
            villa: intl.formatMessage({
              id: 'pdN6LJKohc',
              defaultMessage: 'Villa',
              description: 'Property type label for villa offer cards',
            }),
          },
        )}
      </Caption>
    </Group>
  )
}

export default VillaLocationCaption
